import dashboardSelected from 'assets/sidebarIcons/dashborad_selected.svg';
import dashboardUnselected from 'assets/sidebarIcons/dashborad_unselected.svg';
import usersSelected from 'assets/sidebarIcons/users_selected.svg';
import usersUnselected from 'assets/sidebarIcons/users_unselected.svg';
import foodsSelected from 'assets/sidebarIcons/foods_selected.svg';
import foodsUnselected from 'assets/sidebarIcons/foods_unselected.svg';
import dishSelected from 'assets/sidebarIcons/dish_selected.svg';
import dishUnselected from 'assets/sidebarIcons/dish_unselected.svg';
import dietSelected from 'assets/sidebarIcons/diet_selected.svg';
import dietUnselected from 'assets/sidebarIcons/diet_unselected.svg';
import mealSelected from 'assets/sidebarIcons/meal_selected.svg';
import mealUnselected from 'assets/sidebarIcons/meal_unselected.svg';
import diagnosesSelected from 'assets/sidebarIcons/diagnoses_selected.svg';
import diagnosesUnselected from 'assets/sidebarIcons/diagnoses_unselected.svg';
import allergensSelected from 'assets/sidebarIcons/allergens_selected.svg';
import allergensUnselected from 'assets/sidebarIcons/allergens_unselected.svg';
import foodmapsSelected from 'assets/sidebarIcons/foodmaps_selected.svg';
import foodmapsUnselected from 'assets/sidebarIcons/foodmaps_unselected.svg';
import menuEditorSelected from 'assets/sidebarIcons/meduEditor_selected.svg';
import menuEditorUnselected from 'assets/sidebarIcons/menuEditor_unselected.svg';
import reportsSelected from 'assets/sidebarIcons/reports_selected.svg';
import reportsUnselected from 'assets/sidebarIcons/reports_unselected.svg';
import companySelected from 'assets/sidebarIcons/company_selected.svg';
import companyUnselected from 'assets/sidebarIcons/company_unselected.svg';
import logsSelected from 'assets/sidebarIcons/logs_selected.svg';
import logsUnselected from 'assets/sidebarIcons/logs_unselected.svg';

const SIDEBAR_ICONS = {
  dashboard: {
    selected: dashboardSelected,
    unselected: dashboardUnselected,
  },
  users: {
    selected: usersSelected,
    unselected: usersUnselected,
  },
  foods: {
    selected: foodsSelected,
    unselected: foodsUnselected,
  },
  dish: {
    selected: dishSelected,
    unselected: dishUnselected,
  },
  diet: {
    selected: dietSelected,
    unselected: dietUnselected,
  },
  meal: {
    selected: mealSelected,
    unselected: mealUnselected,
  },
  diagnoses: {
    selected: diagnosesSelected,
    unselected: diagnosesUnselected,
  },
  allergens: {
    selected: allergensSelected,
    unselected: allergensUnselected,
  },
  foodmaps: {
    selected: foodmapsSelected,
    unselected: foodmapsUnselected,
  },
  menuEditor: {
    selected: menuEditorSelected,
    unselected: menuEditorUnselected,
  },
  reports: {
    selected: reportsSelected,
    unselected: reportsUnselected,
  },
  company: {
    selected: companySelected,
    unselected: companyUnselected,
  },
  logs: {
    selected: logsSelected,
    unselected: logsUnselected,
  },
};

export default SIDEBAR_ICONS;
